import { render } from "./SpecialLayout.vue?vue&type=template&id=54e5f01f"
import script from "./SpecialLayout.vue?vue&type=script&lang=js"
export * from "./SpecialLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__